import React from 'react';
import { ReactComponent as ErrorIcon } from '../../assets/img/icons/assistant/Error.svg';

const AIAssistantError = () => {
  return (
    <div className="ai-assistant-status">
      <ErrorIcon />
      <div className="ai-assistant-status-text">Service temporarily unavailable. Please retry.</div>
    </div>
  );
};

export default AIAssistantError;
